export default __webpack_public_path__ + "static/media/Starter pack.fe451fab.pdf";